import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
/* global startPrerenderCapture */

/**
 * Namespace for Breakout.
 * @constant {string}
 */
const utilityNamespace = 'breakOut';

/**
 * Constant for storing namespaced event strings.
 * @constant {object}
 */
const EVENTS = {
  BREAKOUT_INITIALIZED: `BREAKOUT_INIT.${utilityNamespace}`,
};

/**
 * This utility is used to automatically trigger clicks on any element with data attribute
 * `breakout` when prerender has occurred.
 */
class BreakOut {
  /**
   * Initializes the utility.
   * @returns {void}
   */
  init() {
    document.body.setAttribute('data-detectedprerender', 'false');
    const breakoutEls = document.querySelectorAll('[data-breakout]');
    if (breakoutEls.length) {
      document.addEventListener('prerender:loadingComplete', () => {
        document.body.setAttribute('data-detectedprerender', 'true');
        for (let i = 0; i < breakoutEls.length; i += 1) {
          // Take special care not to click an accordion panel that's already open.
          const parentEl = breakoutEls[i].parentNode;
          if (
            !parentEl.classList.contains('accordion-panel')
            || !parentEl.classList.contains('active')
          ) {
            breakoutEls[i].click();
          }
        }

        // Allow prerender snapshot to complete.
        // TODO: Determine whether this is actually doing anything.
        if (typeof startPrerenderCapture === 'function') {
          startPrerenderCapture();
        }
      });
    }
  }

  /**
   * Exposes any events for this utility.
   * @returns {object} The namespaced events object.
   */
  get EVENTS() {
    return EVENTS;
  }
}

/**
 * Single instance of `BreakOut` used to expose this utility.
 * @constant {object}
 */
export default new BreakOut();
